import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', padding: '24px 16px', textAlign: 'center' }}>
      <Helmet>
        <title>Page Not Found | OfferLelo</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div style={{ fontSize: '5rem', marginBottom: 8 }}>🔍</div>
      <h1 style={{ fontSize: '2rem', fontWeight: 800, color: '#1e293b', margin: '0 0 12px' }}>Page Not Found</h1>
      <p style={{ color: '#64748b', fontSize: '1rem', maxWidth: 360, marginBottom: 32, lineHeight: 1.6 }}>
        The page you're looking for doesn't exist or the link may have changed.
      </p>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
        <button
          onClick={() => navigate('/')}
          style={{ padding: '12px 28px', borderRadius: 10, background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)', color: '#fff', border: 'none', fontWeight: 700, fontSize: '1rem', cursor: 'pointer', boxShadow: '0 2px 10px rgba(99,102,241,0.30)' }}>
          Go to Home
        </button>
        <button
          onClick={() => navigate('/offers')}
          style={{ padding: '12px 28px', borderRadius: 10, background: '#fff', color: '#6366f1', border: '2px solid #6366f1', fontWeight: 700, fontSize: '1rem', cursor: 'pointer' }}>
          Browse Offers
        </button>
      </div>
    </div>
  );
}
